import { useEffect, useRef, useState } from "react";
import Input from "../../components/Input/Input";
import styles from "../Pages.module.css";
import Select from "../../components/Select/Select";
import Button from "../../components/Button/Button";
import Table from "../../components/Table/Table";
import { baseURL } from "../../components/utils/utils";
import { useFetch } from "../../hooks/useFetch";
import { useAuthContext } from "../../hooks/useAuthContext";
import { useNavigate } from "react-router-dom";

const Gerentes = () => {
  const { httpGet, httpRequest, setError, error, loading } = useFetch(
    `${baseURL}/gerentes/`
  );
  // Refs para os campos de inputuse

  const nomeRef = useRef(null);
  const statusRef = useRef(null);

  const { user } = useAuthContext();
  const [GerId, setId] = useState("");
  const [GerNome, setNome] = useState("");
  const [GerStatus, setStatus] = useState(0);
  const [gerente, setGerente] = useState({});
  const [data, setData] = useState([]);
  const [formError, setFormError] = useState(null);
  const [isActive, setActive] = useState(false);

  const [nomeHasError, setNomeHasError] = useState(false);
  const [statusHasError, setStatusHasError] = useState(false);

  const head = ["Id", "Nome", "Status"];
  const options = ["...", "Inativo", "Ativo"];
  const navigate = useNavigate();
  useEffect(() => {
    //console.log("carga");
    const getList = async () => {
      if (user && user.token) {
        const dados = await httpGet(user.token, "listar");
        setData(dados);
      } else {
        navigate("/login");
      }
    };
    getList();
  }, [gerente]);

  const handleSave = async (e) => {
    e.preventDefault();
    const nGerente = validaCampos();
    if (nGerente) {
      var endpoint = "inserir";
      if (GerId > 0) {
        endpoint = `atualizar/${GerId}`;
      }
      if (GerNome !== "") {
        const data = await httpRequest(nGerente, user.token, endpoint);
        if (data) {
          setGerente(data);
          handleCancel();
        }
      }
    }
  };

  const handleClickdel = async (gerente) => {
    setActive(true);
    if (
      window.confirm(
        `Tem certeza que deseja excluir o gerente ${gerente.GerNome}?`
      )
    ) {
      const res = await httpRequest(
        gerente,
        user.token,
        `remover/${gerente.GerId}`
      );
      alert(`${res.message}`);
      if (res.success) {
        setGerente(data);
      }
      handleCancel();
    }
  };

  const handleCancel = () => {
    setId(0);
    setNome("");
    setStatus(0); // Atualiza GerStatus para o estado inicial
    handleCleanError();
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleCleanError = () => {
    setFormError("");
    setError("");
  };

  const handleClickUpdate = (gerente) => {
    setId(gerente.GerId);
    setNome(gerente.GerNome);
    setStatus(gerente.GerStatus);
    setGerente(gerente);
    setActive(true);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const validaCampos = () => {
    //console.log(GerNome);
    // Valida o campo Nome
    if (!GerNome || GerNome.trim() === "") {
      setFormError("O campo Nome é obrigatório.");
      setNomeHasError(true);
      nomeRef.current.focus(); // Foca no campo Nome
      return;
    }

    // Valida o campo Status
    if (GerStatus === 0 || GerStatus === "...") {
      setFormError("O campo Status é obrigatório.");
      setStatusHasError(true);
      statusRef.current.focus(); // Foca no campo Status
      return;
    }
    const ngerente = {
      GerId,
      GerNome,
      GerStatus
    };

    return ngerente;
  };

  const handleSelect = (e) => {
    setFormError("");
    setError("");
    const newStatus = e.target.value;
    setStatus(newStatus); // Atualiza GerStatus
  };

  //html
  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Gerentes</h1>
      <div className={styles.card}>
        <Input
          ref={nomeRef} // Referência para o campo Nome
          label="Nome"
          id="GerNome"
          type="text"
          value={(GerNome && GerNome) || ""}
          onChange={(e) => {
            setNome(e.target.value);
            setNomeHasError(false);
            handleCleanError();
          }}
          hasError={nomeHasError} // Aplica a classe de erro se houver erro no nome
        />

        <Select
          ref={statusRef} // Referência para o campo Status
          label="Status"
          id="GerStatus"
          options={options} // Passa o array de status
          value={GerStatus} // Usa o estado do status selecionado
          onChange={(e) => (handleSelect(e), setStatusHasError(false))} // Atualiza o status ao selecionar
          hasError={statusHasError} // Aplica a classe de erro se houver erro no status
        />

        {loading && <p className={styles.loading}>Carregando...</p>}

        {formError && alert(formError)}
        <Button texto="Salvar" onClick={handleSave} active={true} />
        <Button texto="Cancelar" onClick={handleCancel} active={isActive} />
        <Table
          head={head}
          status={options}
          data={data && data}
          onClickUpdate={handleClickUpdate}
          onClickDel={handleClickdel}
          isMaster={user && user.fk_NivId > 2 ? false : true}
        />
      </div>
    </div>
  );
};

export default Gerentes;
